import { render, staticRenderFns } from "./TermsTable.vue?vue&type=template&id=6e3e8095&scoped=true&"
import script from "./TermsTable.vue?vue&type=script&lang=js&"
export * from "./TermsTable.vue?vue&type=script&lang=js&"
import style0 from "./TermsTable.vue?vue&type=style&index=0&id=6e3e8095&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3e8095",
  null
  
)

export default component.exports